import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'ihm-menu-chips-list',
  templateUrl: './ihm-menu-chips-list.component.html',
  styleUrls: ['./ihm-menu-chips-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IhmMenuChipsListComponent),
      multi: true
    }
  ]
})
export class IhmMenuChipsListComponent implements OnInit, ControlValueAccessor {
  @ViewChild('chipInput', {static: false}) chipInput;
  @Output() selectionChange = new EventEmitter();

  // Sets up properties to use with chips.
  @Input() chipsList: Array<any> = [];
  @Input() selectable = true;
  @Input() removable = true;
  @Input() replaceable = false; // Only let one item be selected. Automatically removes all else.
  @Input() minChipsLength = 1;
  @Input() maxChipsLength = 0;

  // allow multiple options to be selected without closing modal
  @Input() modalNoClose = false;

  @Input() displayProperty = 'name';
  @Input() fieldLabel = 'Label';
  @Input() menuTriggerLabel = 'More';
  @Input() menuSelectLabel = 'Select';
  @Input() emptyChipLabel = 'Select';
  @Input() grayedOutOptionsList: Array<any> = [];
  @Input() grayedOutTooltipMessage = '';
  @Input() tooltipMessage = '';

  @Input() optionsList: Array<any> = [
    { id: 1, name: 'Alternative' },
    { id: 2, name: 'Blues' },
    { id: 3, name: 'Classical' },
    { id: 4, name: 'Country' },
    { id: 5, name: 'Dance' },
    { id: 6, name: 'Electronic' },
    { id: 7, name: 'Hip Hop' },
    { id: 8, name: 'Indie' },
    { id: 9, name: 'Jazz' },
    { id: 10, name: 'Latin Music' },
    { id: 11, name: 'Opera' },
    { id: 12, name: 'Pop' },
    { id: 13, name: 'Reggae' },
    { id: 14, name: 'Rock' }
  ];

  propagateChange = (value: any) => {};

  ngOnInit() {
    this.emitSelectionChange();
  }

  toggleChip($event, option): void {
    if (this.replaceable) {
      this.chipsList = [];
    }

    if (this.modalNoClose) {
      $event.stopPropagation();
    }

    this.isOptionSelected(option) ? this.removeChip(option) : this.addChip(option);
  }

  addChip(option: any): void {
    this.chipsList.push(option);
    this.emitSelectionChange();
  }

  removeChip(selectedChip: any): void {
    this.chipsList = _.reject(this.chipsList, selectedChip);
    this.emitSelectionChange();
  }

  emitSelectionChange() {
    this.propagateChange(this.chipsList);
    this.selectionChange.emit(this.chipsList);
  }

  isOptionSelected(option: any): boolean {
    return _.some(this.chipsList, option);
  }

  isDisabled(option: any): boolean {
    return !this.isOptionSelected(option) && this.maxOptionsHasExceeded();
  }

  isOptionGrayedOut(option: any): boolean {
    return _.some(this.grayedOutOptionsList, option);
  }

  shouldDisplayGrayedOutStyle(option: any): boolean {
    const applyMatButton = this.isOptionSelected(option) || this.isOptionGrayedOut(option);
    return applyMatButton;
  }

  getTooltipMessage(option: any): string {
    if (this.isOptionGrayedOut(option)) {
      return this.grayedOutTooltipMessage;
    }
    return this.tooltipMessage;
  }

  maxOptionsHasExceeded(): boolean {
    return this.maxChipsLength > 0 && this.chipsList.length >= this.maxChipsLength;
  }

  writeValue(value: any) {
    if (value) {
      this.chipsList = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}
}
